module.exports = __webpack_public_path__ + "static/media/pdf_icon.8ceb0fde.svg";